import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/24_ekg.jpg"

const EKG24 = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - 24 Stunden EKG </h1>
                    <b> Auch Holter genannt. </b>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Die Durchführung einer Langzeit EKG Messung dient der Aufdeckung von Herzrhythmusstörungen, ( zB. zu langsamer Herzschlag, unregelmässige Palpitationen etc.). Diese Unregelmäßigkeiten können völlig harmlos und ungefährlich sein, bei bestimmten Erkrankungen kann es jedoch zum Bewusstseinsverlust mit nachfolgenden Stürzen inkl. Verletzungen kommen. Zur Abklärung solcher Zustände wird das EKG über mindestens 24 Stunden registriert und ausgewertet.
                        <br /><br />
                        Die Untersuchung ist weder beschwerlich noch unangenehm, der übliche Tagesablauf ist ungestört. Sie bekommen ein kleinen Gerät, an welchem mehrere Elektroden befestigt sind, mit nach Hause (etwa Handygrösse) und Sie können ihren gewohnten Alltag weiter erledigen.
                        <b> Wann führen wir ein 24h EKG durch: </b>
                        <ul>
                            <li>Anfälle von Bewusstlosigkeit (Synkopen), wiederholte Stürze</li>
                            <li>Verdacht auf Schlaganfall bzw. "Vorboten" (TIA) eines Schlaganfalls</li>
                            <li>Schwindel infolge von Rhythmusstörungen</li>
                            <li>Therapiekontrolle bei manchen Herzmedikamenten</li>
                        </ul>
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default EKG24;